import { render } from "./PRIME_MINISTER_NEW.vue?vue&type=template&id=5b231124"
import script from "./PRIME_MINISTER_NEW.vue?vue&type=script&lang=js"
export * from "./PRIME_MINISTER_NEW.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__